export function loadJavascriptSrc(src, integrity) {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script')

    script.src = src
    if (integrity) {
      script.integrity = integrity
      script.crossOrigin = 'anonymous'
    }
    script.onload = () => {
      resolve()
    }
    script.onerror = () => {
      reject(`Error loading: ${src}`)
    }

    document.head.appendChild(script)
  })
}
